import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchIsInProgramme } from "../../redux/actions/preferred-programs";
import axios from "axios";
import * as ROUTES from "../../Router/hotel-group-routes";
import { token } from "../../modules/auth";
import { listFormatter } from "../../utils";
import ReactTooltip from "react-tooltip";
const Badge = ({ text, title, type, className, token, venueId }) => {
  return (
    <div
      data-tip
      data-for={venueId + '_ppbadge_'+type}
      data-event="click"
      className={
        className ??
        "rounded-sm bg-purple py-1 px-2 text-white text-sm font-normal mr-2 text-center cursor-pointer uppercase"
      }
    >
      {text}
    </div>
  );
};

let BadgeToolTip = ({ text, title, type, className, token, venueId  }) => {
  return <ReactTooltip
    id={venueId + '_ppbadge_'+type}
    effect="solid"
    type="light"
    clickable={true}
    className="tooltip-shadow"
    globalEventOff="click"
  >
    <ToolTip
    text={text}
    title={title}
    type={type}
    className={className}
    token={token}
    venueId={venueId}
    />
  </ReactTooltip>
}

const ToolTip = ({text, title, type, className, token, venueId}) => {
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOwners();
  }, []);
  const fetchOwners = async () => {
    if (fetched) return;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(
        window.API +
        ROUTES.API.PREFERRED_PROGRAMMES.GET_OWNERS.replace(":venueId", venueId),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      let names = [];
      if (type === "agency") {
        names = data.agencies?.map((a) => a.name) ?? [];
      } else if (type === "company") {
        names = data.companies?.map((c) => c.name) ?? [];
      } else if (type === "both") {
        names = [
          ...(data.agencies?.map((a) => a.name) ?? []),
          ...(data.companies?.map((c) => c.name) ?? []),
        ];
      }

      setOwners(names);
      setFetched(true);
    } catch (err) {
      console.log(err)
      setError("Failed to load owners");
    } finally {
      setLoading(false);
    }
  };

  let prefix = "";
  if (type === "agency") prefix = "Agency preferred programme";
  else if (type === "company") prefix = "Company preferred programme";
  else if (type === "both") prefix = "Agency and company preferred programme";

  const displayTitle = loading
    ? "Loading…"
    : error
      ? error
      : owners.length > 0
        ? `${prefix} for ${listFormatter.format(owners)}`
        : title;

    return (  <div
      className="text-transform-none"
      style={{ zIndex: "999999" }}
    >

      <strong>{displayTitle}</strong>
      {/*{availableDeals.map(deal => {*/}
      {/*  if(deal.percentage) {*/}
      {/*    return <div><strong>{deal.name}</strong>: <span>{deal.percentage}%</span></div>*/}
      {/*  }*/}
      {/*}) }*/}
    </div>)
}


let PreferredProgrammeBadge = ({
                                 venue,
                                 venueId,
                                 isInProgramme,
                                 displayAgency,
                                 displayCompany,
                                 text,
                                 className,
                                 singleButton = false,
                                 token,
                               }) => {
  let id = venue ? venue.id : venueId;
  if (!isInProgramme || isInProgramme.length === 0) return null;
  const inAgency = isInProgramme.agency?.includes(id);
  const inCompany = isInProgramme.company?.includes(id);
  if (!inAgency && !inCompany) return null;

  let agency = () => {
    return isInProgramme &&
    isInProgramme.agency &&
    inAgency ? (
      <div>
        <Badge
          title={"Agency Preferred Programme"}
          text={text ? text : "Agency Preferred Programme"}
          className={className}
          venueId={id}
          type={"agency"}
          token={token}
        />
        <BadgeToolTip title={"Agency Preferred Programme"}
                      text={text ? text : "Agency Preferred Programme"}
                      className={className}
                      venueId={id}
                      type={"agency"}
                      token={token} />
      </div>

    ) : null;
  };

  let company = () => {
    return isInProgramme &&
    isInProgramme.company &&
    inCompany ? (
      <div>
        <Badge
          title={"Company Preferred Programme"}
          text={text ? text : "Company Preferred Programme"}
          className={className}
          type={"company"}
          venueId={id}
          token={token}
        />
        <BadgeToolTip  title={"Company Preferred Programme"}
                       text={text ? text : "Company Preferred Programme"}
                       className={className}
                       type={"company"}
                       venueId={id}
                       token={token} />
      </div>
    ) : null;
  };

  if (singleButton) {
    if (
      isInProgramme &&
      isInProgramme.agency &&
      inAgency &&
      isInProgramme.company &&
      inCompany
    ) {
      return (
        <div>
          <Badge
            title={"Agency and Company Preferred Programme"}
            text={text ? text : "Agency and Company Preferred Programme"}
            className={className}
            type={"both"}
            venueId={id}
            token={token}
          />
          <BadgeToolTip id={id}    title={"Agency and Company Preferred Programme"}
                        text={text ? text : "Agency and Company Preferred Programme"}
                        className={className}
                        type={"both"}
                        venueId={id}
                        token={token}/>
        </div>

      );
    }
    if (
      isInProgramme &&
      isInProgramme.agency &&
      inAgency
    ) {
      return agency();
    }
    if (
      isInProgramme &&
      isInProgramme.company &&
      inCompany
    ) {
      return company();
    }
  }

  if (displayAgency) {
    return agency();
  }
  if (displayCompany) {
    return company();
  }

  return (
    <div className={'flex'}>
      <div className={'mb-1'}>{agency()}</div>
      <div>{company()}</div>
    </div>
  );
};

export default withRouter(
  connect(
    (state, props) => {
      return {
        token: token(state),
      };
    },
    { fetchIsInProgramme },
  )(PreferredProgrammeBadge),
);
